import { createFileRoute } from '@tanstack/react-router'
import { requireModule, requirePermission } from '../../app/guards'
import { unbilledSearchSchema } from '../../features/reports/project-reports-search'
import { ProjectUnbilledWorkPage } from '../../features/reports/project-unbilled-page'

export const Route = createFileRoute('/_app/project-unbilled-work')({
  staticData: { crumb: 'projectUnbilledWork' },
  validateSearch: unbilledSearchSchema,
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'projects')
    requirePermission(context.session, 'projects.reports')
  },
  component: ProjectUnbilledWorkPage,
})
